import React from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import styled from 'styled-components'
import tire from '../assets/tire.png'
import previous from '../assets/previous.png'

const SearchByPhoto = () => {
    const navigate = useNavigate();
    const handleChange = () => {
        navigate('/loading', { replace: true });
    }
    return (
        <Container>
            <Previous to="/" >Previous</Previous>
            <SubTitle>Continental Car & Van tires</SubTitle>
            <Title>Take or choose a picture of the numbers at your tire</Title>
            <Text>The tire number must be clearly visible in the picture.</Text>
            <Tire src={ tire } />
            <Button>
                {/* <Input accept="image/*" id="icon-button-file" type="file" capture="environment" onChange={handleChange}/> */}
                <Input type="file" accept="image/*" onChange={handleChange}/>

                <p>Start</p>
            </Button>
        </Container>
    );
}

const Container = styled.div`
    width: 90%;
    padding-top: 50px;
    margin: 0 auto;
    text-align: center;
`
const SubTitle = styled.p`
    font-family: ContinentalMedium;
    font-size: 16px;
    margin-bottom: 5px;
`
const Title = styled.p`
    font-family: ContinentalMedium;
    width: 279px;
    margin: 0 auto;
    font-size: 30px;
    line-height: 38px;
    margin-bottom: 20px;
`
const Text = styled.p`
    font-size: 18px;
    font-height: 24px;
    width: 327px;
    margin: 0 auto;
    margin-bottom: 20px;
`
const Tire = styled.img`
    width: 100%;
    margin-bottom: 50px;
`
const Button = styled.label`
    width: 250px;
    height: 50px;
    border: 2px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    font-family: ContinentalMedium;
    font-size: 18px;
    letter-spacing: 0.005em;
`
const Input = styled.input`
    display: none;
`
const Previous = styled(Link)`
    position: absolute;
    font-family: ContinentalBook;
    top: 95px;
    left: 5%;
    color: black;
    text-decoration: none;
    &:before {
        background-image: url(${previous});
        background-size: 7px 13px;
        display: inline-block;
        width: 7px; 
        height: 13px;
        content:"";
        margin-right: 13px;
    }
`
export default SearchByPhoto;